import React, { useEffect, useState } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import markerIcon from "../../assets/icons/marker.png";
import userMarker from "../../assets/icons/user-marker.png";
import RecenterMap from "./RecenterMap";

// Fix para íconos de Leaflet en React
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
    iconUrl: require("leaflet/dist/images/marker-icon.png"),
    shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

const MinimalWazeMap = ({ zonas, userLocation, hasLocation }) => {
    const [mapHeight, setMapHeight] = useState(200);
    if (!userLocation) {
        userLocation = [6.153427, -75.373953]; // Ubicacion por defecto (Medellín)
    }
    return (
        <div
            style={{
                width: "100%",
                height: `${mapHeight}px`,
                borderRadius: "10px",
                overflow: "hidden",
                position: "relative",
            }}
        >
            {/* Botón flotante circular */}
            <button
                onClick={() => setMapHeight(mapHeight === 200 ? 600 : 200)}
                style={{
                    position: "absolute",
                    top: "10px",
                    right: "10px",
                    zIndex: 1000,
                    background: "rgba(28, 31, 38, 0.5)",
                    color: "white",
                    border: "none",
                    borderRadius: "50%",
                    width: "40px",
                    height: "40px",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <span
                    className="material-icons"
                    style={{ fontSize: "20px" }}
                >
                    {mapHeight === 200 ? "fullscreen" : "fullscreen_exit"}
                </span>
            </button>

            <MapContainer
                center={userLocation}
                zoom={15}
                style={{ width: "100%", height: "100%" }}
                zoomControl={false} // 🚫 quita los botones de zoom
                scrollWheelZoom={false} // 🚫 evita zoom con rueda de mouse
                doubleClickZoom={true} // ✅ permite zoom con doble tap/click
                touchZoom={true} // ✅ habilita pinch zoom
                dragging={true} // ✅ permite mover el mapa con un dedo
            >
                <TileLayer
                    attribution=''
                    url="https://basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
                    subdomains={["a", "b", "c", "d"]}
                />

                {/* Recentrar cuando cambia userLocation */}
                {hasLocation && <RecenterMap center={userLocation} />}


                {/* Marcador del usuario */}
                {hasLocation && (
                    <Marker position={userLocation} icon={new L.Icon({
                        iconUrl: userMarker,
                        iconSize: [25, 25],
                        iconAnchor: [12, 25],
                    })}>
                        <Popup>📍 Tu ubicación</Popup>
                    </Marker>
                )}

                {/* Marcadores de las zonas */}
                {zonas.map((zona, index) => (
                    <Marker key={index} position={[zona.lat, zona.lon]} icon={new L.Icon({
                        iconUrl: markerIcon,
                        iconSize: [25, 25],
                        iconAnchor: [12, 25],
                    })}>
                        <Popup>{zona.nombre}</Popup>
                    </Marker>
                ))}
            </MapContainer>
        </div>
    );
};

export default MinimalWazeMap;
